'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var EventEmitter = require('events').EventEmitter;

var assert = require('assert');

var each = require('async/each');

var series = require('async/series');

var parallel = require('async/parallel');

var PeerBook = require('peer-book');

var Switch = require('libp2p-switch');

var Ping = require('libp2p-ping');

var WebSockets = require('libp2p-websockets');

var ConnectionManager = require('libp2p-connection-manager');

var peerRouting = require('./peer-routing');

var contentRouting = require('./content-routing');

var dht = require('./dht');

var pubsub = require('./pubsub');

var getPeerInfo = require('./get-peer-info');

var validateConfig = require('./config').validate;

exports = module.exports;
var NOT_STARTED_ERROR_MESSAGE = 'The libp2p node is not started yet';

var Node =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Node, _EventEmitter);

  function Node(_options) {
    var _this;

    _classCallCheck(this, Node);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this)); // validateConfig will ensure the config is correct,
    // and add default values where appropriate

    _options = validateConfig(_options);
    _this.peerInfo = _options.peerInfo;
    _this.peerBook = _options.peerBook || new PeerBook();
    _this._modules = _options.modules;
    _this._config = _options.config;
    _this._isStarted = false;
    _this._transport = []; // Transport instances/references

    _this._discovery = []; // Discovery service instances/references

    _this._switch = new Switch(_this.peerInfo, _this.peerBook, _options.switch);
    _this.stats = _this._switch.stats;
    _this.connectionManager = new ConnectionManager(_assertThisInitialized(_assertThisInitialized(_this)), _options.connectionManager); // Attach stream multiplexers

    if (_this._modules.streamMuxer) {
      var muxers = _this._modules.streamMuxer;
      muxers.forEach(function (muxer) {
        return _this._switch.connection.addStreamMuxer(muxer);
      }); // If muxer exists
      //   we can use Identify

      _this._switch.connection.reuse(); //   we can use Relay for listening/dialing


      _this._switch.connection.enableCircuitRelay(_this._config.relay); // Received incomming dial and muxer upgrade happened,
      // reuse this muxed connection


      _this._switch.on('peer-mux-established', function (peerInfo) {
        _this.emit('peer:connect', peerInfo);

        _this.peerBook.put(peerInfo);
      });

      _this._switch.on('peer-mux-closed', function (peerInfo) {
        _this.emit('peer:disconnect', peerInfo);
      });
    } // Attach crypto channels


    if (_this._modules.connEncryption) {
      var cryptos = _this._modules.connEncryption;
      cryptos.forEach(function (crypto) {
        _this._switch.connection.crypto(crypto.tag, crypto.encrypt);
      });
    } // Attach private network protector


    if (_this._modules.connProtector) {
      _this._switch.protector = _this._modules.connProtector;
    } else if (process.env.LIBP2P_FORCE_PNET) {
      throw new Error('Private network is enforced, but no protector was provided');
    } // dht provided components (peerRouting, contentRouting, dht)


    if (_this._config.EXPERIMENTAL.dht) {
      var DHT = _this._modules.dht;
      _this._dht = new DHT(_this._switch, {
        kBucketSize: _this._config.dht.kBucketSize || 20,
        // TODO make datastore an option of libp2p itself so
        // that other things can use it as well
        datastore: dht.datastore
      });
    } // enable/disable pubsub


    if (_this._config.EXPERIMENTAL.pubsub) {
      _this.pubsub = pubsub(_assertThisInitialized(_assertThisInitialized(_this)));
    } // Attach remaining APIs


    _this.peerRouting = peerRouting(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.contentRouting = contentRouting(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.dht = dht(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._getPeerInfo = getPeerInfo(_assertThisInitialized(_assertThisInitialized(_this))); // Mount default protocols

    Ping.mount(_this._switch);
    return _this;
  }
  /*
   * Start the libp2p node
   *   - create listeners on the multiaddrs the Peer wants to listen
   */


  _createClass(Node, [{
    key: "start",
    value: function start(callback) {
      var _this2 = this;

      if (!this._modules.transport) {
        return callback(new Error('no transports were present'));
      }

      var ws; // so that we can have webrtc-star addrs without adding manually the id

      var maOld = [];
      var maNew = [];
      this.peerInfo.multiaddrs.toArray().forEach(function (ma) {
        if (!ma.getPeerId()) {
          maOld.push(ma);
          maNew.push(ma.encapsulate('/ipfs/' + _this2.peerInfo.id.toB58String()));
        }
      });
      this.peerInfo.multiaddrs.replace(maOld, maNew);
      var multiaddrs = this.peerInfo.multiaddrs.toArray();

      this._modules.transport.forEach(function (Transport) {
        var t;

        if (typeof Transport === 'function') {
          t = new Transport();
        } else {
          t = Transport;
        }

        if (t.filter(multiaddrs).length > 0) {
          _this2._switch.transport.add(t.tag || t.constructor.name, t);
        } else if (WebSockets.isWebSockets(t)) {
          // TODO find a cleaner way to signal that a transport is always used
          // for dialing, even if no listener
          ws = t;
        }

        _this2._transport.push(t);
      });

      series([function (cb) {
        _this2.connectionManager.start();

        _this2._switch.start(cb);
      }, function (cb) {
        if (ws) {
          // always add dialing on websockets
          _this2._switch.transport.add(ws.tag || ws.constructor.name, ws);
        } // all transports need to be setup before discover starts


        if (_this2._modules.peerDiscovery) {
          each(_this2._modules.peerDiscovery, function (D, _cb) {
            var config = {};

            if (D.tag && _this2._config.peerDiscovery && _this2._config.peerDiscovery[D.tag]) {
              config = _this2._config.peerDiscovery[D.tag];
            } // If not configured to be enabled/disabled then enable by default


            var enabled = config.enabled == null ? true : config.enabled; // If enabled then start it

            if (enabled) {
              var d;

              if (typeof D === 'function') {
                d = new D(Object.assign({}, config, {
                  peerInfo: _this2.peerInfo
                }));
              } else {
                d = D;
              }

              d.on('peer', function (peerInfo) {
                return _this2.emit('peer:discovery', peerInfo);
              });

              _this2._discovery.push(d);

              d.start(_cb);
            } else {
              _cb();
            }
          }, cb);
        } else {
          cb();
        }
      }, function (cb) {
        // TODO: chicken-and-egg problem #1:
        // have to set started here because DHT requires libp2p is already started
        _this2._isStarted = true;

        if (_this2._dht) {
          _this2._dht.start(cb);
        } else {
          cb();
        }
      }, function (cb) {
        // TODO: chicken-and-egg problem #2:
        // have to set started here because FloodSub requires libp2p is already started
        if (_this2._floodSub) {
          _this2._floodSub.start(cb);
        } else {
          cb();
        }
      }, function (cb) {
        // detect which multiaddrs we don't have a transport for and remove them
        var multiaddrs = _this2.peerInfo.multiaddrs.toArray();

        multiaddrs.forEach(function (multiaddr) {
          if (!multiaddr.toString().match(/\/p2p-circuit($|\/)/) && !_this2._transport.find(function (transport) {
            return transport.filter(multiaddr).length > 0;
          })) {
            _this2.peerInfo.multiaddrs.delete(multiaddr);
          }
        });
        cb();
      }, function (cb) {
        _this2.emit('start');

        cb();
      }], callback);
    }
    /*
     * Stop the libp2p node by closing its listeners and open connections
     */

  }, {
    key: "stop",
    value: function stop(callback) {
      var _this3 = this;

      series([function (cb) {
        if (_this3._modules.peerDiscovery) {
          // stop all discoveries before continuing with shutdown
          return parallel(_this3._discovery.map(function (d) {
            return function (_cb) {
              return d.stop(function () {
                _cb();
              });
            };
          }), cb);
        }

        cb();
      }, function (cb) {
        if (_this3._floodSub) {
          return _this3._floodSub.stop(cb);
        }

        cb();
      }, function (cb) {
        if (_this3._dht) {
          return _this3._dht.stop(cb);
        }

        cb();
      }, function (cb) {
        _this3.connectionManager.stop();

        _this3._switch.stop(cb);
      }, function (cb) {
        _this3.emit('stop');

        cb();
      }], function (err) {
        _this3._isStarted = false;
        callback(err);
      });
    }
  }, {
    key: "isStarted",
    value: function isStarted() {
      return this._isStarted;
    }
  }, {
    key: "dial",
    value: function dial(peer, callback) {
      var _this4 = this;

      assert(this.isStarted(), NOT_STARTED_ERROR_MESSAGE);

      this._getPeerInfo(peer, function (err, peerInfo) {
        if (err) {
          return callback(err);
        }

        _this4._switch.dial(peerInfo, function (err) {
          if (err) {
            return callback(err);
          }

          _this4.peerBook.put(peerInfo);

          callback();
        });
      });
    }
  }, {
    key: "dialProtocol",
    value: function dialProtocol(peer, protocol, callback) {
      var _this5 = this;

      assert(this.isStarted(), NOT_STARTED_ERROR_MESSAGE);

      if (typeof protocol === 'function') {
        callback = protocol;
        protocol = undefined;
      }

      this._getPeerInfo(peer, function (err, peerInfo) {
        if (err) {
          return callback(err);
        }

        _this5._switch.dial(peerInfo, protocol, function (err, conn) {
          if (err) {
            return callback(err);
          }

          _this5.peerBook.put(peerInfo);

          callback(null, conn);
        });
      });
    }
  }, {
    key: "hangUp",
    value: function hangUp(peer, callback) {
      var _this6 = this;

      assert(this.isStarted(), NOT_STARTED_ERROR_MESSAGE);

      this._getPeerInfo(peer, function (err, peerInfo) {
        if (err) {
          return callback(err);
        }

        _this6._switch.hangUp(peerInfo, callback);
      });
    }
  }, {
    key: "ping",
    value: function ping(peer, callback) {
      var _this7 = this;

      if (!this.isStarted()) {
        return callback(new Error(NOT_STARTED_ERROR_MESSAGE));
      }

      this._getPeerInfo(peer, function (err, peerInfo) {
        if (err) {
          return callback(err);
        }

        callback(null, new Ping(_this7._switch, peerInfo));
      });
    }
  }, {
    key: "handle",
    value: function handle(protocol, handlerFunc, matchFunc) {
      this._switch.handle(protocol, handlerFunc, matchFunc);
    }
  }, {
    key: "unhandle",
    value: function unhandle(protocol) {
      this._switch.unhandle(protocol);
    }
  }]);

  return Node;
}(EventEmitter);

module.exports = Node;